import { render, staticRenderFns } from "./inpatientList.vue?vue&type=template&id=30488e94&scoped=true&"
import script from "./inpatientList.vue?vue&type=script&lang=js&"
export * from "./inpatientList.vue?vue&type=script&lang=js&"
import style0 from "./inpatientList.vue?vue&type=style&index=0&id=30488e94&scoped=true&lang=css&"
import style1 from "./inpatientList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30488e94",
  null
  
)

export default component.exports